<div class="pt-2 formly-container">
  <kendo-tabstrip #tabstripFlag [tabPosition]="'left'" (tabSelect)="onTabSelect($event)">
    <kendo-tabstrip-tab [selected]="true">
      <ng-template kendoTabTitle>
        <i class="fas fa-pencil-ruler icon-width"></i>&nbsp;{{ 'FORM-DESIGN' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
        <div class="formly-form-container">
          <div class="text-center pb-3">
            <kendo-dropdownbutton *ngIf="!isDeleted" [data]="listControlTypes" (itemClick)="onAddControlClick($event)">
              {{'ADD' | translate}}<kendo-svgicon class="ml-1" [icon]="icons.caretDown"></kendo-svgicon>
              <ng-template kendoDropDownButtonItemTemplate let-dataItem>
                <div>
                  <span class="field-dropdown-icon fas {{dataItem.icon}}"></span>
                  <span class="ml-2">{{dataItem.text}}</span>
                </div>
              </ng-template>
            </kendo-dropdownbutton>
            <button kendoButton class="float-right" type="button" title="{{'IMPORT-FORM' | translate}}"
              *ngIf="!isDeleted" (click)="selectJsonFile()">
              {{'IMPORT-FORM' | translate}}<i class="far fa-file-import"></i>
            </button>
            <kendo-upload class="d-none" [autoUpload]="false" [multiple]="false" (select)="onFileChanged($event)">
            </kendo-upload>
          </div>
          <span *ngIf="(!fields || fields.length === 0) && !loading">{{'NO-FORM-DATA-DISPLAY' | translate}}</span>
          <div class="row">
            <div *ngIf="loading" class="col my-auto">
              <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
          </div>
          <!--Formly Designer Template-->
          <div [ngTemplateOutlet]="formlyDesigner" [ngTemplateOutletContext]="{fields: fields}"></div>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [disabled]="(!fields || fields.length === 0)" *ngIf="!isDeleted">
      <ng-template kendoTabTitle>
        <i class="fas fa-eye icon-width"></i>&nbsp;{{ 'FORM-PREVIEW' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
        <div class="formly-form-design">
          <div class="row">
            <div *ngIf="loading" class="col my-auto">
              <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
          </div>
          <form [formGroup]="form" class="k-form" *ngIf="!loading">
            <formly-form [form]="form" [fields]="fieldsPreview" [model]="model"></formly-form>
          </form>
          <div class="mt-3">
            <hr />
            <button kendoButton (click)="reset()" class="mr-4">
              {{'FORM-RESET' | translate}}
            </button>
            <span class="green text-center" *ngIf="form.valid && form.dirty">{{'FORM-VALID' | translate}}</span>
            <span class="red text-center" *ngIf="!form.valid && form.dirty">{{'FORM-INVALID' | translate}}</span>
          </div>
          <div class="mt-3" style="padding-left:1px">
            <input id="showModel" type="checkbox" [checked]="showModel" [(ngModel)]="showModel" kendoCheckBox />
            <label class="k-checkbox-label" for="showModel">{{ 'FORM-SHOW-MODEL' | translate }}</label>
          </div>
          <div class="mt-3 mb-3" *ngIf="showModel">
            <p class="text-monospace">
              {{ model | json }}
            </p>
          </div>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <!--Assessment Channels-->
    <kendo-tabstrip-tab [disabled]="(!fields || fields.length === 0)">
      <ng-template kendoTabTitle>
        <i class="fas fa-cubes icon-width"></i>&nbsp;{{ 'CHANNELS' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
        <app-formly-designer-channel-edit [isDeleted]="isDeleted" [model]="channels" [fields]="fields"
          (formChanged)="onChannelFormChanged($event)">
        </app-formly-designer-channel-edit>
      </ng-template>
    </kendo-tabstrip-tab>
    <!--Assessment Flags-->
    <kendo-tabstrip-tab [disabled]="(!fields || fields.length === 0)">
      <ng-template kendoTabTitle>
        <i class="fas fa-flag orange icon-width"></i>&nbsp;{{ 'FLAGS' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
        <app-formly-designer-flag-edit [isDeleted]="isDeleted" [model]="flags" [fields]="fields"
          (formChanged)="onFlagFormChanged($event)">
        </app-formly-designer-flag-edit>
      </ng-template>
    </kendo-tabstrip-tab>
    <!--Assessment Needs-->
    <kendo-tabstrip-tab *ngIf="communityEnabled && !consentTypeAssessment"
      [disabled]="(!fields || fields.length === 0)">
      <ng-template kendoTabTitle>
        <i class="far fa-universal-access icon-width"></i>&nbsp;{{ 'NEEDS' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
        <app-formly-designer-need-edit [isDeleted]="isDeleted" [model]="needs" [fields]="fields"
          (formChanged)="onNeedFormChanged($event)">
        </app-formly-designer-need-edit>
      </ng-template>
    </kendo-tabstrip-tab>
    <!--Assessment Risk Scores-->
    <kendo-tabstrip-tab *ngIf="communityEnabled && !consentTypeAssessment"
      [disabled]="(!fields || fields.length === 0)">
      <ng-template kendoTabTitle>
        <i class="fas fa-analytics icon-width"></i>&nbsp;{{ 'RISK-SCORES' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
        <app-formly-designer-service-type-edit [isDeleted]="isDeleted" [model]="serviceTypes" [fields]="fields"
          (formChanged)="onServiceTypeFormChanged($event)">
        </app-formly-designer-service-type-edit>
      </ng-template>
    </kendo-tabstrip-tab>
    <!--Assessment Tasks-->
    <kendo-tabstrip-tab [disabled]="(!fields || fields.length === 0)">
      <ng-template kendoTabTitle>
        <i class="fas fa-tasks icon-width"></i>&nbsp;{{ 'TASKS' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
        <app-formly-designer-task-edit [assessmentId]="assessmentId" [isDeleted]="isDeleted" [model]="tasks"
          [fields]="fields" [assessmentModel]="model" (formChanged)="onTaskFormChanged($event)">
        </app-formly-designer-task-edit>
      </ng-template>
    </kendo-tabstrip-tab>
    <!--Rules Summary-->
    <kendo-tabstrip-tab [disabled]="(!fields || fields.length === 0)">
      <ng-template kendoTabTitle>
        <i class="far fa-ruler-combined icon-width"></i>&nbsp;{{ 'SUMMARY' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
        <app-formly-designer-summary [needs]="needs" [flags]="flags" [tasks]="tasks" [fields]="fields"
          [channels]="channels" [serviceTypes]="serviceTypes">
        </app-formly-designer-summary>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>

<app-formly-designer-field-edit [isNew]="isNew" [isCopy]="isCopy" [consentTypeAssessment]="consentTypeAssessment"
  [fields]="fields" [model]="fieldEditModel" [usedKeys]="usedKeys" (cancelling)="onCancelEditField()"
  (apply)="onApplyEditField($event)">
</app-formly-designer-field-edit>

<!--Designer Controls per type-->
<ng-template #formlyDesigner let-fields="fields">
  <kendo-sortable #sortable [data]="fields" [animation]="true" *ngIf="fields && fields.length > 0 && !loading"
    (dragStart)="onDragStart($event)" (dragEnd)="onDragEnd()" (dragOver)="onDragOver($event, sortable)">
    <ng-template let-field="item" let-index="index">
      <div class="col-12 designer-field-border p-3 w-100 mt-3 pointer" id="{{field?.key}}">
        <label *ngIf="field.key" class="key-hint" (click)="copyKeyToClipboard(field.key)">{{field.key}}</label>
        <!--Action buttons: Hide buttons if draging started-->
        <div *ngIf="!isDeleted && !dragStarted" class="buttons-position" (mouseenter)="mouseEnterActionButtonsDiv()"
          (mouseleave)="mouseLeaveActionButtonsDiv()">
          <i class="fas fa-edit fa-lg" *ngIf="field.template === undefined || field.templateOptions !== undefined"
            title="{{'EDIT' | translate}}" (click)="editField(field)"></i>
          &nbsp;
          <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}" (click)="deleteField(index, fields)"></i>
          <span *ngIf="field.type !== 'tabs'">
            &nbsp;
            <i class="fas fa-copy fa-lg" title="{{'COPY' | translate}}" (click)="copyField(field)"></i>
          </span>
        </div>
        <div [ngClass]="{'mt-3': field.type !== 'tabs'}">
          <!--Field label-->
          <div *ngIf="field.type !== 'checkbox' && field.template === undefined && field.type !== 'label'">
            <label title="{{ 'FORM-KEY' | translate }}&nbsp;=&nbsp;{{field.key}}"
              style="max-width:90%">{{field.templateOptions.label}}
            </label>
          </div>
          <!--Input Type-->
          <ng-container *ngIf="field.type === 'input'">
            <input type="text" kendoTextBox placeholder="{{field.templateOptions.placeholder}}" [disabled]="true"
              class="{{field.templateOptions.className}}" />
          </ng-container>
          <!--Select-->
          <ng-container *ngIf="field.type === 'select'">
            <kendo-combobox [disabled]="true" [data]="field.templateOptions.options" [textField]="'label'"
              [valueField]="'value'" [valuePrimitive]="false" class="{{field.templateOptions.className}}">
            </kendo-combobox>
          </ng-container>
          <!--Multi Select-->
          <ng-container *ngIf="field.type === 'multiselect'">
            <kendo-combobox [disabled]="true" [data]="field.templateOptions.options" [textField]="'label'"
              [valueField]="'value'" [valuePrimitive]="false" class="{{field.templateOptions.className}}">
            </kendo-combobox>
          </ng-container>
          <!--Date-->
          <ng-container *ngIf="field.type === 'date'">
            <kendo-datepicker [disabled]="true" class="{{field.templateOptions.className}}">
            </kendo-datepicker>
          </ng-container>
          <!--Date Time-->
          <ng-container *ngIf="field.type === 'datetime'">
            <kendo-datetimepicker [disabled]="true" class="{{field.templateOptions.className}}">
            </kendo-datetimepicker>
          </ng-container>
          <!--Textarea-->
          <ng-container *ngIf="field.type === 'textarea'">
            <textarea kendoTextArea [disabled]="true" class="{{field.templateOptions.className}}"
              placeholder="{{field.templateOptions.placeholder}}"></textarea>
          </ng-container>
          <!--Checkbox-->
          <ng-container *ngIf="field.type === 'checkbox'">
            <input [disabled]="true" id="{{field.id}}" type="checkbox" kendoCheckBox />
            <label title="{{ 'FORM-KEY' | translate }}&nbsp;=&nbsp;{{field.key}}" for="{{field.id}}"
              class="k-checkbox-label">{{field.templateOptions.label}}</label>
          </ng-container>
          <!--Radio-->
          <ng-container *ngIf="field.type === 'radio'">
            <ng-container *ngFor="let option of field.templateOptions.options; let i=index;">
              <div class="ml-4">
                <input [disabled]="true" type="radio" /> <label
                  class="k-radio-label {{field.templateOptions.className}}" style="margin-right: 2rem" kendoRadioButton>
                  {{ option.label }}
                </label>
              </div>
            </ng-container>
          </ng-container>
          <!--Multi Checkbox-->
          <ng-container *ngIf="field.type === 'multicheckbox'">
            <ng-container *ngFor="let option of field.templateOptions.options; let i=index;">
              <div class="ml-4">
                <input [disabled]="true" type="checkbox" kendoCheckBox />
                <label class="k-checkbox-label {{field.templateOptions.className}}" style="margin-right: 2rem"
                  for="{{field.id}}">
                  {{ option.label }}
                </label>
              </div>
            </ng-container>
          </ng-container>
          <!--Tab-->
          <ng-container *ngIf="field.type === 'tabs'">
            <kendo-tabstrip class="formly-tab-background-white p-3">
              <ng-container *ngFor="let tab of field.fieldGroup; let i=index;">
                <kendo-tabstrip-tab title="{{ tab.templateOptions.label }}" [selected]="i === 0">
                  <ng-template kendoTabContent>
                    <!--Call formlyDesigner recursively-->
                    <div [ngTemplateOutlet]="formlyDesigner" [ngTemplateOutletContext]="{fields: tab.fieldGroup}"></div>
                  </ng-template>
                </kendo-tabstrip-tab>
              </ng-container>
            </kendo-tabstrip>
          </ng-container>
          <!--Header-->
          <ng-container *ngIf="field.template !== undefined">
            <ng-container>
              <h4 class="montserrat" *ngIf="field.templateOptions" innerHTML="{{ field.templateOptions.label }}"></h4>
              <hr class="m-0" />
            </ng-container>
          </ng-container>
          <!--Label Text-->
          <ng-container *ngIf="field.templateOptions && field.templateOptions.type === 'label'">
            <div [innerHTML]="field.templateOptions.description | safe:'html'"></div>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </kendo-sortable>
</ng-template>